/**
 * Build/release identity, injected at build time by vite.config.ts.
 *
 * `RELEASE` is the value stored on every frontend error event so crash rates can
 * be compared deployment-to-deployment (e.g. `1.4.0+9f2c1ab`).
 */
declare const __APP_VERSION__: string;
declare const __APP_BUILD_COMMIT__: string;
declare const __APP_BUILD_TIME__: string;

function read(value: string | undefined, fallback: string): string {
  return value && value !== "undefined" ? value : fallback;
}

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== "undefined" ? read(__APP_VERSION__, "0.0.0") : "0.0.0";

export const BUILD_COMMIT: string =
  typeof __APP_BUILD_COMMIT__ !== "undefined" ? read(__APP_BUILD_COMMIT__, "local") : "local";

export const BUILD_TIME: string =
  typeof __APP_BUILD_TIME__ !== "undefined"
    ? read(__APP_BUILD_TIME__, new Date(0).toISOString())
    : new Date(0).toISOString();

export const RELEASE: string =
  (import.meta.env.VITE_APP_RELEASE as string | undefined) ||
  `${APP_VERSION}+${BUILD_COMMIT.slice(0, 7)}`;
